import React from 'react';
import { Breadcrumb } from '@shared/components/breadcrumb/Breadcrumb';
import { getPageTitle } from '@shared/services/pageTitleService';
import { canUserAccessSeveralOrganization } from '@shared/services/userAccessibilityService';
import { Page } from '../../../layout';
import CheckpointForm from '../common/CheckpointForm';
import { PAGE_VIEW_MODES } from '../../../../constants/page-view-modes';

/**
 * @typedef {object} EditCheckpointPageProps
 * @property {string} [dataCollectionDate]
 * @property {number} orgUnitId
 * @property {string} [orgUnitName]
 * @property {string} [orgName]
 * @property {number} appraisalId
 * @property {number} checkPointId
 * @property {React.ReactNode} [renderedOrgUnit]
 * @property {boolean} orgUnitLoading
 * @property {boolean} checkPointLoading
 * @property {string} [tier]
 */

/**
 * @param {EditCheckpointPageProps} props
 */
const EditCheckpointPage = props => {
  const {
    orgUnitId,
    appraisalId,
    checkPointId,
    orgUnitName,
    renderedOrgUnit,
    orgUnitLoading,
    checkPointLoading,
    dataCollectionDate,
    tier,
    orgName
  } = props;

  const previousLink = `/check-points/${orgUnitId}/view-check-point/${appraisalId}/${checkPointId}`;

  const description =
    'Use the first table below to remove, replace, or upload new documents. ' +
    'Use the second table below to update metric status and/or fields. ' +
    'When finished, click the “Submit” button to complete changes. ' +
    'Otherwise click the “Cancel” button to go back to the previous page.';

  const title = 'Edit Check Point';
  const successfullyMessage = 'Check Point updated successfully.';

  const pageTitle = getPageTitle([orgUnitName, 'Edit Check Point']);

  const annotationCommonItems = [renderedOrgUnit, `Appraisal ${appraisalId}`, dataCollectionDate];

  const annotationItems = canUserAccessSeveralOrganization(tier)
    ? [orgName, ...annotationCommonItems]
    : annotationCommonItems;

  const breadcrumbPathItems = [
    { name: 'Check Points', url: `/check-points/${orgUnitId}` },
    { name: 'View Check Points', url: previousLink },
    { name: 'Edit Check Point', url: '' }
  ];

  return (
    <Page title={pageTitle} className='check-point-page'>
      <Breadcrumb
        pathItems={breadcrumbPathItems}
        annotationItems={annotationItems}
        loading={orgUnitLoading}
      />

      <CheckpointForm
        title={title}
        description={description}
        successfullyMessage={successfullyMessage}
        previousLink={previousLink}
        orgUnitId={orgUnitId}
        appraisalId={appraisalId}
        viewMode={PAGE_VIEW_MODES.EDIT}
        loading={checkPointLoading}
        checkPointId={checkPointId}
      />
    </Page>
  );
};

export default EditCheckpointPage;
